// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__N4PIe","spinner":"LoadingSpinner_spinner__IGdBV","spin":"LoadingSpinner_spin__Hkrmm"};